<template>
  <v-row justify="center">
    <v-dialog v-model="showModal" persistent max-width="800px">
      <v-card :loading="loading" :disabled="cardDisabled">
        <v-card-title>
          <span class="headline">Token</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-alert
              text
              prominent
              dismissible
              v-model="alertShow"
              type="error"
              icon="mdi-alert"
              >{{ alertText }}</v-alert
            >
            <v-form ref="form" v-model="valid">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    :label="descriptionLabel"
                    :rules="descriptionRules"
                    :error-messages="errorMessages"
                    v-model="description"
                    :class="{ 'disable-events': !updateEnable }"
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    :items="roles"
                    item-text="name"
                    item-value="id"
                    :no-data-text="rolesNoDataLabel"
                    v-model="selectedRoles"
                    :class="{ 'disable-events': !updateEnable }"
                    :label="rolesLabel"
                    chips
                    deletable-chips
                    multiple
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" class="outlinedButton">
                  <v-btn
                    class="ma-2"
                    tile
                    outlined
                    color="red"
                    v-if="deleteEnable"
                    dense
                    @click="deleteToken"
                  >
                    <v-icon left>mdi-delete</v-icon>
                    {{ $t("Delete Token") }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" text @click="hide">{{ $t("close") }}</v-btn>
          <v-btn
            color="darken-1"
            text
            :disabled="!valid"
            v-if="updateEnable"
            @click="updateToken"
            >{{ $t("save") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from "axios";
import i18n from "../../../i18n";
import EventBus from "../../../event-bus";

export default {
  name: "UpdateTokenModal",
  data: () => ({
    valid: true,
    showModal: false,
    loading: true,
    cardDisabled: true,
    errorMessages: [],
    id: "",
    alertText: null,
    alertShow: false,
    description: "",
    descriptionLabel: i18n.t("Description"),
    descriptionRules: [],
    roles: [],
    rolesLabel: i18n.t("Roles"),
    rolesNoDataLabel: i18n.t("No roles available"),
    selectedRoles: [],
    updateEnable: false,
    deleteEnable: false,
  }),
  created() {
    this.descriptionRules = [
      (v) => !!v || i18n.t("Description is required"),
      (v) => v.length <= 100 || i18n.t("Max 100 characters"),
    ];
  },
  mounted() {
    // Permissions
    if (typeof this.$store.getters.resources.permissions !== "undefined") {
      let permissions = this.$store.getters.resources.permissions;

      if (this.checkNested(permissions, "tokens", "delete")) {
        this.deleteEnable = true;
      }

      if (this.checkNested(permissions, "tokens", "update")) {
        this.updateEnable = true;
      }
    }
  },
  methods: {
    sendErrorAndCloseModal(error) {
      if (error.response) {
        if (
          error.response.status == 400 &&
          error.response.data.status == "error"
        ) {
          EventBus.$emit("SHOW_ERROR", error.response.data.error);
        } else {
          EventBus.$emit("SHOW_ERROR", error.response.data);
        }
      } else {
        EventBus.$emit("SHOW_ERROR", error);
      }

      this.loading = false;
      this.showModal = false;
    },
    sendErrorOnModal(error) {
      if (error.response) {
        if (
          error.response.status == 400 &&
          error.response.data.status == "error"
        ) {
          this.alertText = error.response.data.error;
        } else {
          this.alertText = error.response.data;
        }
      } else {
        this.alertText = error;
      }

      this.loading = false;
      this.alertShow = true;
    },
    show(id) {
      this.showModal = true;
      this.alertShow = false;
      this.alertText = "";

      let getToken = axios.get("/api/v1/permissions/token/" + id);
      let getRoles = axios.get(
        "/api/v1/permissions/roles?filter=id,name&gui=false"
      );

      axios
        .all([getToken, getRoles])
        .then(
          axios.spread((...responses) => {
            const token = responses[0];
            const roles = responses[1];

            this.loading = false;
            this.cardDisabled = false;
            this.id = token.data.token.id;
            this.description = token.data.token.description;
            this.roles = roles.data.list;
            this.selectedRoles = [];

            let i = 0;
            for (i = 0; i < token.data.token.roles.length; i++) {
              this.selectedRoles.push(token.data.token.roles[i].id);
            }
          })
        )
        .catch((errors) => {
          console.log(errors);
          this.sendErrorAndCloseModal(errors);
        });
    },
    updateToken() {
      this.loading = true;

      let data = {};

      if (this.description != "") {
        data.description = this.description;
      }

      let roles = [];
      let i = 0;

      for (i = 0; i < this.selectedRoles.length; i++) {
        roles.push(this.selectedRoles[i]);
      }

      data.roles = roles;

      axios
        .put("/api/v1/permissions/token/" + this.id, data)
        .then((response) => {
          this.loading = false;
          this.showModal = false;

          if (
            !response.data ||
            !response.data.status ||
            !(response.data.status == "done")
          ) {
            this.showModal = false;
            EventBus.$emit("SHOW_ERROR", response);
          } else {
            this.$parent.$parent.updateTable();
          }
        })
        .catch((error) => {
          this.sendErrorOnModal(error);
        });
    },
    deleteToken() {
      this.loading = true;

      axios
        .delete("/api/v1/permissions/token/" + this.id)
        .then((response) => {
          this.loading = false;
          this.showModal = false;

          if (
            !response.data ||
            !response.data.status ||
            !(response.data.status == "done")
          ) {
            EventBus.$emit("SHOW_ERROR", response);
          } else {
            this.$parent.$parent.updateTable();
          }
        })
        .catch((error) => {
          this.sendErrorAndCloseModal(error);
        });
    },
    hide() {
      this.showModal = false;
    },
    checkNested(obj, level, ...rest) {
      if (obj === undefined) return false;
      if (rest.length == 0 && {}.hasOwnProperty.call(obj, level)) return true;
      return this.checkNested(obj[level], ...rest);
    },
  },
};
</script>

<style scoped>
.v-alert {
  overflow: hidden;
}

.outlinedButton {
  padding: 0px !important;
}

.disable-events {
  pointer-events: none;
}
</style>